(function () {
  'use strict';

  // ===== NEW バッジ設定（商品作成日ベース・タグ不要） =====
  var NEW_DAYS = 7;                  // 公開から何日間 NEW 扱いにするか
  var NEW_BADGE_TEXT = 'NEW!';
  var NEW_BADGE_BG = '#D32F2F';
  var NEW_BADGE_COLOR = '#ffffff';
  var NEW_MS = NEW_DAYS * 24 * 60 * 60 * 1000;

  // ===== Product data cache =====
  var badgeData = null;
  var productCache = {};
  var dateData = null;
  var dateDataEl = null;

  // Fabric は View Transition で body ごと差し替わるため、
  // script 要素の同一性を見て再パースする
  function loadDateData() {
    var el = document.getElementById('a97-product-dates');
    if (el === dateDataEl && dateData !== null) return dateData;
    dateDataEl = el;
    if (!el) { dateData = {}; return dateData; }
    try { dateData = JSON.parse(el.textContent); } catch (e) { dateData = {}; }
    return dateData;
  }

  // Liquid の date:'%z' は "+0900"、/products/{handle}.js は "+09:00" を返す。
  // 前者をコロン付きに正規化してから Date.parse に渡す（後者は正規表現に当たらず素通り）。
  function parseShopifyDate(v) {
    if (!v) return null;
    var t = Date.parse(String(v).replace(/([+-]\d{2})(\d{2})$/, '$1:$2'));
    return isNaN(t) ? null : t;
  }

  // 判定は published_at ではなく created_at を使う。Shopify の「新着順」
  // （sort_by=created-descending）が created_at ベースのため、published_at だと
  // 再公開された商品に NEW が付くのに新着順では上位に来ない、という食い違いが起きる。
  function isNewProduct(created) {
    var t = parseShopifyDate(created);
    if (t === null) return false;
    return (Date.now() - t) < NEW_MS;
  }

  function handleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = link.getAttribute('href').match(/\/products\/([^?#]+)/);
    return m ? m[1] : null;
  }

  function loadBadgeData() {
    if (badgeData !== null) return badgeData;
    var el = document.getElementById('a97-card-badges');
    if (!el) { badgeData = []; return badgeData; }
    try { badgeData = JSON.parse(el.textContent); } catch (e) { badgeData = []; }
    return badgeData;
  }

  function fetchProductData(handle) {
    return new Promise(function (resolve) {
      if (productCache[handle]) { resolve(productCache[handle]); return; }
      // .json ではなく .js を使う。tags に加えて available（Shopifyの在庫真値）が取れるため。
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var result = { tags: [], available: null, created_at: null };
          if (data.tags) {
            result.tags = typeof data.tags === 'string'
              ? data.tags.split(', ')
              : data.tags;
          }
          // 取得できなかった場合は null のままにして、バッヂ操作を一切行わない。
          if (typeof data.available === 'boolean') result.available = data.available;
          result.created_at = data.created_at || null;
          productCache[handle] = result;
          resolve(result);
        })
        .catch(function () {
          productCache[handle] = { tags: [], available: null, created_at: null };
          resolve(productCache[handle]);
        });
    });
  }

  // ===== Fabric product cards =====
  function processCard(card) {
    if (card.dataset.a97Fixed) return;
    card.dataset.a97Fixed = '1';
    var title = card.querySelector('p[role="heading"]') || card.querySelector('h3');
    if (!title || title.querySelector('br')) return;
    title.innerHTML = title.innerHTML.replace(/(?!^)【/g, '<br>【');
  }

  // ===== Fabric product cards: NEW バッジ注入（同期・fetch不要） =====
  function injectFabricNewBadge(card) {
    if (card.dataset.a97New) return;
    var handle = handleFromCard(card);
    if (!handle) return;
    card.dataset.a97New = '1';

    var dates = loadDateData();
    if (!isNewProduct(dates[handle])) return;

    var wrap = card.querySelector('.product-badges');
    if (!wrap) {
      var gallery = card.querySelector('.card-gallery');
      if (!gallery) return;
      wrap = document.createElement('div');
      wrap.className = 'product-badges product-badges--top-left';
      gallery.appendChild(wrap);
    }
    if (wrap.querySelector('.a97-badge-new')) return;

    var el = document.createElement('div');
    el.className = 'product-badges__badge product-badges__badge--rectangle a97-badge-new';
    el.textContent = NEW_BADGE_TEXT;
    el.style.background = NEW_BADGE_BG;
    el.style.color = NEW_BADGE_COLOR;
    wrap.insertBefore(el, wrap.firstChild);
  }

  function initBadges() {
    if (document.querySelector('.product-badges__badge')) {
      document.querySelector('.product-grid')?.classList.add('has-badges');
    }
  }

  document.querySelectorAll('product-card').forEach(function (card) {
    processCard(card);
    injectFabricNewBadge(card);
  });
  initBadges();

  // ===== Globo product cards: title fix + vendor removal (sync) =====
  // 規則は product-page-fix.js の injectProductCatLabel と揃える
  function stripVendorFromTitle(el, vendor) {
    if (!vendor || el.children.length) return;
    // innerHTML で比較すると G&G が G&amp;G になり一致しない
    var text = el.textContent;
    var prefix = text.match(/^(\s*(?:【[^】]*】\s*)*)/)[1];
    var rest = text.slice(prefix.length);
    if (rest.toLowerCase().indexOf(vendor.toLowerCase()) !== 0) return;
    el.textContent = prefix + rest.slice(vendor.length).replace(/^\s+/, '').replace(/^[\/／]\s*/, '');
  }

  function processGloboCard(card) {
    if (card.dataset.a97Fixed) return;
    card.dataset.a97Fixed = '1';

    var titleEl = card.querySelector('.spf-product-card__title a');
    if (!titleEl) return;

    var vendorEl = card.querySelector('.spf-product-card__vendor a');
    if (vendorEl) stripVendorFromTitle(titleEl, vendorEl.textContent.trim());

    if (!titleEl.querySelector('br')) {
      titleEl.innerHTML = titleEl.innerHTML.replace(/(?!^)【/g, '<br>【');
    }
  }

  // ===== Globo product cards: 0円 → 「注文内容によって変動」 =====
  function fixZeroPrice(card) {
    var priceWrap = card.querySelector('.spf-product-card__price-wrapper');
    if (!priceWrap || priceWrap.dataset.a97Zero) return;
    var prices = priceWrap.querySelectorAll('.money');
    if (!prices.length) return;
    var allZero = Array.from(prices).every(function (p) {
      return parseInt(p.textContent.replace(/[^\d]/g, ''), 10) === 0;
    });
    if (allZero) {
      priceWrap.dataset.a97Zero = '1';
      priceWrap.innerHTML = '<span class="a97-variable-price">金額：注文内容によって変動</span>';
    }
  }

  // ===== Globo product cards: moneyクラス復元Observer =====
  function observeMoneyClass(card) {
    if (card.dataset.a97MoneyObs) return;
    card.dataset.a97MoneyObs = '1';
    var priceWrap = card.querySelector('.spf-product-card__price-wrapper');
    if (!priceWrap) return;
    new MutationObserver(function () {
      if (priceWrap.dataset.a97Zero) {
        var priceEl = priceWrap.querySelector('.spf-product-card__price, .spf-product-card__saleprice');
        var currentPrice = priceEl ? parseInt(priceEl.textContent.replace(/[^\d]/g, ''), 10) || 0 : 0;
        if (currentPrice === 0 && !priceWrap.querySelector('.a97-variable-price')) {
          priceWrap.innerHTML = '<span class="a97-variable-price">金額：注文内容によって変動</span>';
          return;
        } else if (currentPrice > 0) {
          priceWrap.dataset.a97Zero = '';
        }
      }
      priceWrap.querySelectorAll(
        '.spf-product-card__price:not(.money),' +
        '.spf-product-card__oldprice:not(.money),' +
        '.spf-product-card__saleprice:not(.money)'
      ).forEach(function (el) { el.classList.add('money'); });
    }).observe(priceWrap, { childList: true, subtree: true });
  }

  // ===== Swatch modal CSS =====
  function injectSwatchModalCSS() {
    if (document.getElementById('a97-swatch-modal-css')) return;
    var style = document.createElement('style');
    style.id = 'a97-swatch-modal-css';
    style.textContent =
      '.a97-swatch-modal-overlay{position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.4);z-index:10000;display:flex;align-items:center;justify-content:center;}' +
      '.a97-swatch-modal{background:#fff;border-radius:12px;padding:20px;max-width:360px;width:90%;max-height:70vh;overflow-y:auto;box-shadow:0 8px 30px rgba(0,0,0,0.15);}' +
      '.a97-swatch-modal__header{display:flex;justify-content:space-between;align-items:flex-start;margin-bottom:12px;}' +
      '.a97-swatch-modal__title{font-size:14px;font-weight:600;line-height:1.4;padding-right:10px;}' +
      '.a97-swatch-modal__close{background:none;border:none;font-size:20px;cursor:pointer;color:#999;padding:0;line-height:1;flex-shrink:0;}' +
      '.a97-swatch-modal__list{display:flex;flex-direction:column;gap:6px;}' +
      '.a97-swatch-modal__item{display:flex;align-items:center;gap:10px;padding:8px 10px;border:1px solid #e0e0e0;border-radius:8px;cursor:pointer;font-size:13px;transition:background 0.15s;}' +
      '.a97-swatch-modal__item:hover{background:#f8f8f8;}' +
      '.a97-swatch-modal__item.is-selected{border-color:#333;background:#fafafa;}' +
      '.a97-swatch-modal__swatch{width:24px;height:24px;border-radius:50%;border:1px solid #ccc;flex-shrink:0;background-size:cover;background-position:center;}' +
      '.a97-swatch-modal__price{margin-left:auto;color:#888;font-size:12px;}' +
      '.spf-product__swatch.is-soldout .spf-product__swatch-inner{opacity:0.35;position:relative;overflow:hidden;}' +
      '.spf-product__swatch.is-soldout .spf-product__swatch-inner::after{content:"";position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(to top right,transparent 43%,#888 43%,#888 57%,transparent 57%);pointer-events:none;}' +
      '.a97-swatch-modal__item.is-soldout{opacity:0.4;}';
    document.head.appendChild(style);
  }

  // ===== Swatch modal (「+N」展開) =====
  function openSwatchModal(card) {
    injectSwatchModalCSS();
    var sel = card.querySelector('select.spf-product__variants');
    if (!sel) return;
    var titleEl = card.querySelector('.spf-product-card__title a');
    var productTitle = titleEl ? titleEl.textContent.trim() : '';
    var currentVal = sel.value;
    var container = card.querySelector('.spf-product__swatchs');

    var overlay = document.createElement('div');
    overlay.className = 'a97-swatch-modal-overlay';

    var modal = document.createElement('div');
    modal.className = 'a97-swatch-modal';

    var header = document.createElement('div');
    header.className = 'a97-swatch-modal__header';
    var titleSpan = document.createElement('span');
    titleSpan.className = 'a97-swatch-modal__title';
    titleSpan.textContent = productTitle;
    var closeBtn = document.createElement('button');
    closeBtn.className = 'a97-swatch-modal__close';
    closeBtn.textContent = '\u00d7';
    header.appendChild(titleSpan);
    header.appendChild(closeBtn);

    var list = document.createElement('div');
    list.className = 'a97-swatch-modal__list';

    Array.from(sel.options).forEach(function (opt) {
      var optName = opt.getAttribute('data-option1') || opt.textContent.trim();
      if (optName === 'Default Title') return;
      var price = parseInt(opt.getAttribute('data-price') || '0', 10);
      var priceStr = price > 0 ? price.toLocaleString('ja-JP') + ' \u5186' : '';

      var item = document.createElement('div');
      var isOOS = opt.getAttribute('data-available') === 'false';
      item.className = 'a97-swatch-modal__item' + (opt.value === currentVal ? ' is-selected' : '') + (isOOS ? ' is-soldout' : '');

      var swEl = container ? container.querySelector('.spf-product__swatch[data-option-value="' + optName + '"]') : null;
      if (swEl) {
        var inner = swEl.querySelector('.spf-product__swatch-inner');
        if (inner && inner.style.background) {
          var dot = document.createElement('span');
          dot.className = 'a97-swatch-modal__swatch';
          dot.style.background = inner.style.background;
          if (inner.style.backgroundSize) dot.style.backgroundSize = inner.style.backgroundSize;
          if (inner.style.backgroundPosition) dot.style.backgroundPosition = inner.style.backgroundPosition;
          item.appendChild(dot);
        }
      }

      var label = document.createElement('span');
      label.textContent = optName;
      item.appendChild(label);

      if (priceStr) {
        var priceSpan = document.createElement('span');
        priceSpan.className = 'a97-swatch-modal__price';
        priceSpan.textContent = priceStr;
        item.appendChild(priceSpan);
      }

      item.addEventListener('click', function () {
        if (swEl) {
          swEl.style.display = '';
          swEl.click();
          card.dataset.a97SwatchLayout = '';
          var oldBadge = container && container.querySelector('.a97-swatch-more');
          if (oldBadge) oldBadge.remove();
          container.querySelectorAll('.spf-product__swatch').forEach(function (s) {
            s.style.display = '';
            s.classList.remove('a97-swatch-shrink');
          });
          layoutSwatches(card);
        } else {
          sel.value = opt.value;
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        }
        overlay.remove();
      });

      list.appendChild(item);
    });

    modal.appendChild(header);
    modal.appendChild(list);
    overlay.appendChild(modal);
    document.body.appendChild(overlay);

    closeBtn.addEventListener('click', function () { overlay.remove(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.remove(); });
  }

  // ===== Globo product cards: スウォッチ1行レイアウト + 「+N」モーダル =====
  function layoutSwatches(card) {
    if (card.dataset.a97SwatchLayout) return;
    var container = card.querySelector('.spf-product__swatchs');
    if (!container) return;

    var inner = card.querySelector('.spf-product-card__inner') || container.parentElement;
    if (!inner || inner.getBoundingClientRect().width === 0) {
      setTimeout(function () { layoutSwatches(card); }, 100);
      return;
    }

    card.dataset.a97SwatchLayout = '1';

    var swatches = Array.from(container.querySelectorAll('.spf-product__swatch'));
    if (swatches.length === 0) return;

    var selectedSw = swatches.find(function (s) { return s.classList.contains('is-selected'); });
    if (selectedSw && swatches[0] !== selectedSw) {
      container.insertBefore(selectedSw, swatches[0]);
      swatches = Array.from(container.querySelectorAll('.spf-product__swatch'));
    }

    var badge = document.createElement('span');
    badge.className = 'a97-swatch-more';
    badge.textContent = '+' + swatches.length;
    badge.addEventListener('click', function (e) {
      e.stopPropagation();
      openSwatchModal(card);
    });
    container.appendChild(badge);

    var SAFETY = 2;
    var GAP = 4;
    var badgeWidth = badge.getBoundingClientRect().width;
    var availableRight = inner.getBoundingClientRect().right - SAFETY;
    var listRight = availableRight - badgeWidth - GAP;

    var hiddenCount = 0;
    var firstVisibleIdx = -1;
    for (var i = swatches.length - 1; i >= 0; i--) {
      if (swatches[i].getBoundingClientRect().right > listRight) {
        swatches[i].style.display = 'none';
        hiddenCount++;
      } else {
        firstVisibleIdx = i;
        break;
      }
    }

    if (firstVisibleIdx === -1) {
      swatches[0].style.display = '';
      swatches[0].classList.add('a97-swatch-shrink');
      hiddenCount = swatches.length - 1;
    }

    var visibleSwatches = swatches.filter(function (s) { return s.style.display !== 'none'; });
    if (visibleSwatches.length > 0) {
      var firstVisible = visibleSwatches[0];
      var firstLeft = firstVisible.getBoundingClientRect().left;
      var maxAllowedW = listRight - firstLeft;
      var naturalW = firstVisible.getBoundingClientRect().width;
      if (naturalW > maxAllowedW && maxAllowedW > 20) {
        firstVisible.classList.add('a97-swatch-shrink');
        firstVisible.style.maxWidth = maxAllowedW + 'px';
      }
    }

    if (hiddenCount === 0) {
      badge.style.display = 'none';
    } else {
      badge.textContent = '+' + hiddenCount;
    }

    updateSelectedName(card);
  }

  // ===== Globo product cards: badge injection (async) =====
  function processGloboCardBadges(card) {
    if (card.dataset.a97Badge) return;
    card.dataset.a97Badge = '1';

    var inner = card.querySelector('.spf-product-card__inner');
    if (!inner) return;

    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;

    var match = link.getAttribute('href').match(/\/products\/([^?#]+)/);
    if (!match) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'a97-badges';

    var existingLabels = inner.querySelectorAll(':scope > .spf-product__label');
    existingLabels.forEach(function (label) {
      wrapper.appendChild(label);
    });

    var imgWrap = inner.querySelector('.spf-product-card__image-wrapper');
    if (imgWrap) {
      inner.insertBefore(wrapper, imgWrap);
    } else {
      inner.prepend(wrapper);
    }

    fetchProductData(match[1]).then(function (product) {
      injectGloboBadges(wrapper, product.tags, product.created_at);
      // MutationObserver 経由の ensureSoldoutLabel は fetch 解決前に走り終わるため、
      // ここで明示的に呼ばないと在庫判定が反映されない。
      ensureSoldoutLabel(card);
    });
  }

  function injectGloboBadges(wrapper, productTags, createdAt) {
    // NEW バッジは metaobject のバッジ定義に依存しないので先に処理する
    if (isNewProduct(createdAt) && !wrapper.querySelector('.a97-badge-new')) {
      var newEl = document.createElement('span');
      newEl.className = 'a97-badge a97-badge-new';
      newEl.textContent = NEW_BADGE_TEXT;
      newEl.style.background = NEW_BADGE_BG;
      newEl.style.color = NEW_BADGE_COLOR;
      wrapper.insertBefore(newEl, wrapper.firstChild);
    }

    var badges = loadBadgeData();
    if (!badges.length) return;

    var matching = badges.filter(function (b) {
      if (!b.tags) return false;
      var requiredTags = b.tags.split(',').map(function (t) { return t.trim(); });
      return requiredTags.every(function (rt) { return productTags.includes(rt); });
    });

    matching.forEach(function (b) {
      var el = document.createElement('span');
      el.className = 'a97-badge';
      el.textContent = b.text;
      el.style.background = b.bg;
      el.style.color = b.color;
      wrapper.appendChild(el);
    });
  }

  // ===== Globo product cards: 完全在庫切れ時のソールドアウトバッヂ フォールバック =====
  // 判定根拠は Globo の data-available ではなく /products/{handle}.js の available。
  // Globoのインデックスが遅れていると data-available が古い値を返し、
  // 品切れ商品にバッヂが付かない（かつ在庫あり扱いで並び替えられる）。
  function ensureSoldoutLabel(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var match = link.getAttribute('href').match(/\/products\/([^?#]+)/);
    if (!match) return;

    var product = productCache[match[1]];
    if (!product || product.available === null) return; // 未取得・取得失敗時は触らない

    var globoLabel = card.querySelector('.spf-product__label-soldout:not(.a97-badge-soldout-fallback)');
    var fallback = card.querySelector('.a97-badge-soldout-fallback');

    if (product.available) {
      if (fallback) fallback.remove();
      // 複数バリアント商品の soldout ラベルは bindSwatchClick が
      // バリアント単位で出し入れしているので、ここでは触らない。
      var sel = card.querySelector('select.spf-product__variants');
      if (globoLabel && (!sel || sel.options.length <= 1)) globoLabel.remove();
      return;
    }

    if (globoLabel || fallback) return;

    var wrapper = card.querySelector('.a97-badges');
    if (!wrapper) return;

    var label = document.createElement('span');
    label.className = 'spf-product__label spf-product__label-soldout a97-badge-soldout-fallback';
    label.textContent = '\u4E00\u6642\u54C1\u5207\u4E2D';
    wrapper.insertBefore(label, wrapper.firstChild);
  }

  // ===== Globo product cards: カラースウォッチ色丸注入 + 画像切替 =====
  var SWATCH_SIZE = '20px';
  var SWATCH_BORDER = '1px solid #ccc';
  var SWATCH_BORDER_SELECTED = '2px solid #333';
  var SWATCH_REGEX = /value="([^"]+)"[^>]*>\s*<span[^>]*--swatch-background:\s*([^;]+);/g;
  var swatchColorCache = {};
  var SWATCH_STORAGE_KEY = 'a97-swatch-colors';

  try {
    var stored = sessionStorage.getItem(SWATCH_STORAGE_KEY);
    if (stored) swatchColorCache = JSON.parse(stored);
  } catch (e) {}

  function saveSwatchCache() {
    try {
      sessionStorage.setItem(SWATCH_STORAGE_KEY, JSON.stringify(swatchColorCache));
    } catch (e) {}
  }

  // 商品ページHTML全体（実測 約3,100KB）を引くと重いため、Section Rendering API で
  // product-information セクションだけを取得する（実測 約220KB / 約93%削減）。
  // セクションIDはテンプレートごとに異なるが、別テンプレートのIDを指定しても
  // リクエストした商品のデータでレンダリングされ、同じスウォッチ値が取れることを実測で確認済み。
  // テーマ更新でIDが変わると404になるので、その場合はフルページ取得に自動で切り替える。
  var PRODUCT_SECTION_ID = 'template--22181081153771__product-information';
  var sectionIdUsable = true;

  function parseSwatchColors(html) {
    var map = {};
    var m;
    SWATCH_REGEX.lastIndex = 0;
    while ((m = SWATCH_REGEX.exec(html)) !== null) {
      map[m[1].trim()] = m[2].trim();
    }
    return map;
  }

  function fetchSwatchColors(productPath) {
    if (swatchColorCache[productPath]) {
      return Promise.resolve(swatchColorCache[productPath]);
    }
    var url = sectionIdUsable
      ? productPath + '?section_id=' + PRODUCT_SECTION_ID
      : productPath;

    return fetch(url)
      .then(function (r) {
        if (r.ok) return r.text();
        if (sectionIdUsable) {
          sectionIdUsable = false; // 以降は全件フルページに切り替え
          return fetch(productPath).then(function (r2) {
            return r2.ok ? r2.text() : '';
          });
        }
        return '';
      })
      .then(function (html) {
        var map = parseSwatchColors(html);
        swatchColorCache[productPath] = map;
        saveSwatchCache();
        return map;
      })
      .catch(function () { return {}; });
  }

  function bgExtra(colorValue) {
    return colorValue.indexOf('url(') !== -1
      ? 'background-size:cover;background-position:center;'
      : '';
  }

  function createSwatchDot(colorValue, optionName, isSelected, isAvailable) {
    var span = document.createElement('span');
    span.className = 'spf-product__swatch' + (isSelected ? ' is-selected' : '') + (isAvailable === false ? ' is-soldout' : '');
    span.setAttribute('data-option', '1');
    span.setAttribute('data-option-value', optionName);
    span.title = optionName;

    var inner = document.createElement('span');
    inner.className = 'spf-product__swatch-inner';
    inner.style.cssText =
      'display:inline-block;' +
      'width:' + SWATCH_SIZE + ';' +
      'height:' + SWATCH_SIZE + ';' +
      'border-radius:50%;' +
      'background:' + colorValue + ';' +
      bgExtra(colorValue) +
      'border:' + (isSelected ? SWATCH_BORDER_SELECTED : SWATCH_BORDER) + ';' +
      'vertical-align:middle;cursor:pointer;';

    span.appendChild(inner);
    return span;
  }

  function bindSwatchClick(card) {
    if (card.dataset.a97SwatchClick) return;
    card.dataset.a97SwatchClick = '1';

    var container = card.querySelector('.spf-product__swatchs');
    if (!container) return;

    container.addEventListener('click', function (e) {
      var swatch = e.target.closest('.spf-product__swatch');
      if (!swatch) return;

      var optionValue = swatch.getAttribute('data-option-value');
      if (!optionValue) return;

      var sel = card.querySelector('select.spf-product__variants');
      if (!sel) return;

      var targetOpt = Array.from(sel.options).find(function (o) {
        return (o.getAttribute('data-option1') || o.textContent.trim()) === optionValue;
      });
      if (!targetOpt) return;

      sel.value = targetOpt.value;

      var variantImage = targetOpt.getAttribute('data-image');
      if (variantImage) {
        var imgWrapper = card.querySelector('.spf-product-card__image-wrapper');
        if (imgWrapper) {
          var variantFile = variantImage.split('?')[0].split('/').pop().replace(/_\d+x\d+/, '');
          var allImgs = imgWrapper.querySelectorAll('img');
          var matchImg = null;
          allImgs.forEach(function (img) {
            if (img.src.includes(variantFile.replace(/\.\w+$/, ''))) {
              matchImg = img;
            }
          });
          if (matchImg) {
            var currentMain = card.querySelector('.spf-product-card__image-main');
            if (currentMain && currentMain !== matchImg) {
              currentMain.classList.remove('spf-product-card__image-main');
              currentMain.classList.add('spf-product-card__image-secondary');
            }
            matchImg.classList.remove('spf-product-card__image-secondary', 'spf-product-card__image-hidden');
            matchImg.classList.add('spf-product-card__image-main');
          }
        }
      }

      card.querySelectorAll('a[href*="/products/"]').forEach(function (link) {
        var baseUrl = link.getAttribute('href').split('?')[0];
        link.setAttribute('href', baseUrl + '?variant=' + targetOpt.value);
      });

      container.querySelectorAll('.spf-product__swatch').forEach(function (sw) {
        sw.classList.remove('is-selected');
        var inner = sw.querySelector('.spf-product__swatch-inner');
        if (inner) inner.style.border = SWATCH_BORDER;
      });
      swatch.classList.add('is-selected');
      var selectedInner = swatch.querySelector('.spf-product__swatch-inner');
      if (selectedInner) selectedInner.style.border = SWATCH_BORDER_SELECTED;

      var badgeWrapper = card.querySelector('.a97-badges');
      if (badgeWrapper) {
        var soldLabel = badgeWrapper.querySelector('.spf-product__label-soldout');
        if (targetOpt.getAttribute('data-available') === 'false') {
          if (!soldLabel) {
            soldLabel = document.createElement('span');
            soldLabel.className = 'spf-product__label spf-product__label-soldout';
            soldLabel.textContent = '\u4E00\u6642\u54C1\u5207\u4E2D';
            badgeWrapper.appendChild(soldLabel);
          }
          soldLabel.style.removeProperty('display');
        } else {
          if (soldLabel) soldLabel.style.setProperty('display', 'none', 'important');
        }
      }
      updateSelectedName(card);
    });
  }

  // ===== 視覚スウォッチの選択中名称をスウォッチ列の下に表示 =====
  function isVisualSwatch(sw) {
    var inner = sw.querySelector('.spf-product__swatch-inner');
    if (!inner) return false;
    var text = inner.querySelector('.spf-product__swatch-text');
    if (!text) return true;
    var ts = getComputedStyle(text);
    if (ts.display === 'none') return true;
    return false;
  }

  function updateSelectedName(card) {
    var container = card.querySelector('.spf-product__swatchs');
    if (!container) return;
    var next = container.nextElementSibling;
    if (next && next.classList && next.classList.contains('a97-swatch-name')) {
      next.remove();
    }
    var selectedSw = container.querySelector('.spf-product__swatch.is-selected');
    if (!selectedSw) return;
    if (!isVisualSwatch(selectedSw)) return;
    var name = selectedSw.getAttribute('data-option-value') || '';
    if (!name) return;
    var label = document.createElement('span');
    label.className = 'a97-swatch-name';
    label.textContent = name;
    container.insertAdjacentElement('afterend', label);
  }

  function processGloboCardSwatches(card) {
    if (card.dataset.a97Swatch) return;

    var sel = card.querySelector('select.spf-product__variants');
    if (!sel || sel.options.length <= 1) return;

    var realOptions = Array.from(sel.options).filter(function (o) {
      return o.textContent.trim() !== 'Default Title';
    });
    if (realOptions.length <= 1) return;

    var link = card.querySelector('.spf-product-card__title a');
    if (!link) return;

    var href = link.getAttribute('href').split('?')[0];

    card.dataset.a97Swatch = '1';

    fetchSwatchColors(href).then(function (colorMap) {
      var swatchMap = {};
      var hasAnySwatch = false;
      Array.from(sel.options).forEach(function (opt) {
        var optName = opt.getAttribute('data-option1') || opt.textContent.trim();
        if (optName === 'Default Title') return;
        if (colorMap[optName]) {
          swatchMap[optName] = colorMap[optName];
          hasAnySwatch = true;
        } else {
          var img = opt.getAttribute('data-image');
          if (img) {
            swatchMap[optName] = 'url(' + img + ')';
            hasAnySwatch = true;
          }
        }
      });

      var selectedValue = sel.options[sel.selectedIndex]
        ? (sel.options[sel.selectedIndex].getAttribute('data-option1') ||
           sel.options[sel.selectedIndex].textContent.trim())
        : '';

      var swatchContainer = card.querySelector('.spf-product__swatchs');

      if (!hasAnySwatch) {
        bindSwatchClick(card);
        layoutSwatches(card);
        return;
      }

      if (swatchContainer) {
        swatchContainer.querySelectorAll('.spf-product__swatch').forEach(function (sw) {
          var val = sw.getAttribute('data-option-value');
          if (swatchMap[val]) {
            var matchOpt = Array.from(sel.options).find(function (o) {
              return (o.getAttribute('data-option1') || o.textContent.trim()) === val;
            });
            if (matchOpt && matchOpt.getAttribute('data-available') === 'false') {
              sw.classList.add('is-soldout');
            }
            var inner = sw.querySelector('.spf-product__swatch-inner');
            if (inner) {
              inner.style.cssText =
                'display:inline-block;' +
                'width:' + SWATCH_SIZE + ';' +
                'height:' + SWATCH_SIZE + ';' +
                'border-radius:50%;' +
                'background:' + swatchMap[val] + ';' +
                bgExtra(swatchMap[val]) +
                'border:' + (sw.classList.contains('is-selected') ? SWATCH_BORDER_SELECTED : SWATCH_BORDER) + ';' +
                'vertical-align:middle;cursor:pointer;';
              var text = inner.querySelector('.spf-product__swatch-text');
              if (text) text.style.display = 'none';
            }
          }
        });
      } else {
        var priceWrapper = card.querySelector('.spf-product-card__price-wrapper');
        if (!priceWrapper) return;

        var newContainer = document.createElement('div');
        newContainer.className = 'spf-product__swatchs';
        newContainer.style.cssText = 'margin-top:4px;';

        Array.from(sel.options).forEach(function (opt) {
          var optName = opt.getAttribute('data-option1') || opt.textContent.trim();
          if (optName === 'Default Title') return;
          var bg = swatchMap[optName];
          if (!bg) return;
          var avail = opt.getAttribute('data-available') !== 'false';
          newContainer.appendChild(createSwatchDot(bg, optName, optName === selectedValue, avail));
        });

        if (newContainer.children.length > 0) {
          priceWrapper.insertAdjacentElement('afterend', newContainer);
        }
      }

      bindSwatchClick(card);
      layoutSwatches(card);
    });
  }

  // ===== Shared observer =====
  new MutationObserver(function (mutations) {
    for (var m of mutations) {
      for (var node of m.addedNodes) {
        if (node.nodeType !== 1) continue;
        if (node.matches?.('product-card')) {
          processCard(node);
          injectFabricNewBadge(node);
        } else {
          node.querySelectorAll?.('product-card').forEach(function (c) {
            processCard(c);
            injectFabricNewBadge(c);
          });
        }
      }
    }
    document.querySelectorAll('.spf-product-card').forEach(function (card) {
      processGloboCard(card);
      fixZeroPrice(card);
      observeMoneyClass(card);
      processGloboCardBadges(card);
      ensureSoldoutLabel(card);
      processGloboCardSwatches(card);
    });
    initBadges();
  }).observe(document.body, { childList: true, subtree: true });
})();